import types from "./types";

const initialState = {
    formErrors: [],
};

export default function formReducer(state = initialState, action) {
    switch (action.type) {
        case types.INIT_FORM: {
            const { formId, initialValues = {} } = action.payload;
            return {
                ...state,
                [formId]: initialValues,
            };
        }
        case types.RESET_FORM: {
            const { formId } = action.payload;
            const { [formId]: _, ...rest } = state;
            return rest;
        }
        case types.SET_FORM_ERRORS: {
            const updatedArray = [...state.formErrors, action.payload];

            return {
                ...state,
                formErrors: updatedArray,
            };
        }
        case types.REMOVE_FORM_ERROR: {
            const newErrors = state.formErrors.filter(({ name }) => !name.includes(action.payload));

            return {
                ...state,
                formErrors: newErrors,
            };
        }
        case types.RESET_FORM_ERRORS: {
            return {
                ...state,
                formErrors: [],
            };
        }
        default:
            return state;
    }
}
